export const GA_MEASUREMENT_ID = "G-DC3YSQCYJL";

function isGtagReady() {
  return typeof window !== "undefined" && typeof window.gtag === "function";
}

export function trackEvent(eventName, params = {}) {
  if (!isGtagReady()) {
    return;
  }

  window.gtag("event", eventName, params);
}

export function trackPageView({ path, title, location, language, pageType }) {
  if (!isGtagReady()) {
    return;
  }

  window.gtag("event", "page_view", {
    page_path: path,
    page_title: title,
    page_location: location,
    language,
    page_type: pageType,
  });
}

export function trackWebVital(metric) {
  const value = metric.name === "CLS" ? Math.round(metric.value * 1000) : Math.round(metric.value);

  trackEvent(metric.name, {
    event_category: "Web Vitals",
    event_label: metric.id,
    value,
    metric_id: metric.id,
    metric_value: metric.value,
    metric_delta: metric.delta,
    metric_rating: metric.rating,
    non_interaction: true,
  });
}

export function classifyLink(url) {
  if (!url) {
    return null;
  }

  if (url.protocol === "mailto:") {
    return "email";
  }

  if (url.protocol === "tel:") {
    return "phone";
  }

  const downloadExtensions = [".pdf", ".zip", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx"];
  const pathname = url.pathname.toLowerCase();

  if (downloadExtensions.some((extension) => pathname.endsWith(extension))) {
    return "download";
  }

  if (url.origin !== window.location.origin) {
    return "external";
  }

  return null;
}
